// extracted by mini-css-extract-plugin
export default {"wrapper":"e47LzZeimgJ1PFrwd7r8","badge":"fjXfDxargO3_ALi1rww1"};